import { CmsPublicationContent } from '../../../../components/Cms';

export function CmsPublicationDetailContent() {
  return <CmsPublicationContent />;
}
